export const build_deck_columns = (length) =>
  Array.from({ length })
    .map(() => 'auto')
    .join(' ');
